/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".login-loader[_ngcontent-%COMP%]{background-color:#fff;height:500px;position:absolute;top:35px;z-index:1;opacity:.8;border-radius:10px;max-width:1250px;padding:0;margin:0;width:100%}.error-message[_ngcontent-%COMP%]{color:red}.investor-login[_ngcontent-%COMP%]{width:100%;text-align:center;display:block;color:#5bc8ca}"];
export { styles as styles };
